/**
 * The sentences a partner sees for the billing refusals. The shared table
 * (api/errors.ts ERROR_MESSAGES) is keyed by the contract's "Error codes as
 * shipped"; until these codes are listed there, the billing screens put the
 * prose on the error themselves so ErrorNotice never says "Something
 * unexpected happened" for a refusal we know.
 */
import { ApiError, isKnownCode } from '../api/errors';

export const BILLING_ERROR_PROSE: Readonly<Record<string, string>> = {
  FEE_SCHEDULE_OUTDATED:
    'The Contractor Fee Schedule was updated while this page was open. Reload the page and review the current version.',
  FEE_SCHEDULE_REQUIRED:
    'An owner or admin needs to accept the Contractor Fee Schedule on the Billing page before leads can be accepted.',
  LEAD_NOT_ACCEPTABLE:
    'This lead can no longer be accepted here: it may have been closed, expired or already accepted. Reload the page to see where it stands.',
  BILLING_NOT_ENABLED: 'Billing isn’t switched on for your organisation yet.',
};

/** The same error with billing prose when the shared table has none; anything else unchanged. */
export function billingError(error: ApiError | null): ApiError | null {
  if (!error) return null;
  const prose = BILLING_ERROR_PROSE[error.code];
  if (!prose || isKnownCode(error.code)) return error;
  return new ApiError({
    status: error.status,
    code: error.code,
    message: prose,
    correlationId: error.correlationId,
    fields: error.fields,
    body: error.body,
  });
}
